module.exports = __webpack_public_path__ + "static/media/springboot.104b7eea.png";